import { render } from "./HomeButtonLottery.vue?vue&type=template&id=9b3eae5a&scoped=true"
const script = {}

import "./HomeButtonLottery.vue?vue&type=style&index=0&id=9b3eae5a&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b3eae5a"]])

export default __exports__